export interface FAQItem {
  id: string;
  question: string;
  answer: string;
}

export const faqs: FAQItem[] = [
  {
    id: 'faq-1',
    question: '如何找到众赢zygjb的最新官方入口地址？',
    answer: '您可以收藏本页面，我们会实时更新众赢zygjb最新官方入口地址。建议通过浏览器书签保存本页面，避免通过搜索引擎点击不明广告链接。官方入口地址变更时，本页面将第一时间同步更新，确保您始终能够通过安全通道访问平台。',
  },
  {
    id: 'faq-2',
    question: '众赢zygjb平台是否安全可靠？',
    answer: '众赢zygjb是经过严格安全认证的正版平台，采用先进的加密技术保护玩家信息和资金安全。平台拥有专业的安全团队7x24小时监控防护，同时建立了完善的玩家保障机制。所有交易均在加密环境下进行，确保您的每一次操作都安全无忧。',
  },
  {
    id: 'faq-3',
    question: '忘记众赢zygjb平台账号密码怎么办？',
    answer: '在登录页面点击"忘记密码"，按照提示通过绑定的手机号或邮箱进行身份验证后即可重置密码。如果绑定的手机号或邮箱已不再使用，请联系平台客服进行人工身份验证和密码重置。建议密码重置后立即更新账号安全设置。',
  },
  {
    id: 'faq-4',
    question: '众赢zygjb平台支持哪些设备访问？',
    answer: '众赢zygjb平台全面支持PC端（Windows/Mac）、移动端（iOS/Android手机和平板）访问。PC端推荐使用Chrome、Edge或Firefox浏览器获得最佳体验。移动端可通过手机浏览器直接访问，无需下载额外应用。平台界面会根据设备自动适配，确保不同屏幕尺寸下的良好体验。',
  },
  {
    id: 'faq-5',
    question: '如何联系众赢zygjb平台客服？',
    answer: '您可以通过以下方式联系我们的官方客服团队：1. 平台内在线客服（7x24小时在线）；2. 官方客服邮箱；3. 官方社交媒体账号私信。我们的客服团队将竭诚为您服务，通常在工作时间内5分钟内即可得到响应。',
  },
  {
    id: 'faq-6',
    question: '众赢zygjb平台有哪些支付方式？',
    answer: '平台支持多种主流支付方式，具体可支持的支付方式请在平台"充值中心"页面查看最新列表。所有支付通道均经过安全认证，交易过程全程加密，保障您的资金安全。如需帮助，请随时联系在线客服。',
  },
  {
    id: 'faq-7',
    question: '新手注册众赢zygjb平台有哪些福利？',
    answer: '新注册玩家可享受专属新手礼包，包括新手任务奖励、首次充值优惠等多重福利。具体福利内容以平台当前活动页面展示为准。完成新手引导任务后还可以获得额外奖励，帮助您快速融入平台。请关注平台公告了解最新活动信息。',
  },
  {
    id: 'faq-8',
    question: '众赢zygjb平台可以多设备同时登录吗？',
    answer: '出于账号安全考虑，同一账号在同一时间只能在一个设备上登录。当您在新设备登录时，之前设备上的登录状态会自动失效。如您需要在多设备间切换使用，只需在目标设备上重新登录即可。如果您发现账号在异常设备上登录，请立即修改密码并联系客服。',
  },
];